module.exports = __webpack_public_path__ + "img/teacher6.0d0a974c.webp";